/**
 * avatars/items/body-accessories.js
 * Xây dựng hình học 3D cho createBodyAccessory - Dispatcher Registry
 */

import * as THREE from 'three';
import { BODY_ACCESSORIES_REGISTRY } from './accessories/index.js';

export function createBodyAccessory(lib, type, torsoW, torsoH, torsoD, opts = {}) {
  const accGroup = new THREE.Group();
  accGroup.name = `BodyAcc_${type}`;
  const handY = opts.handY ?? 0.55;
  const sideX = opts.armOffsetX ?? torsoW * 0.7;

  const builder = BODY_ACCESSORIES_REGISTRY[type];
  if (builder) {
    builder(lib, accGroup, torsoW, torsoH, torsoD, opts, handY, sideX);
  }

  return accGroup;
}
